module.exports = __webpack_public_path__ + "img/teeth-23.e20b8104.png";